<template>
    <page title="roleRequestsTitle" :help="help">
        <template #pageContainer>
            <v-row>
                <!-- <v-col
                    cols="12"
                    md="12">
                    <v-card outlined>
                        <v-row
                            align="center"
                            justify="center">
                            <v-col
                                cols="12"
                                md="4"
                                sm="4">
                                <v-card-text>
                                    <v-icon>remove_circle</v-icon>
                                    {{ $t(`text.removeRequestButtonInfo`) }}
                                </v-card-text>
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                                sm="4">
                                <v-card-text>
                                    <v-icon>done</v-icon>
                                    {{ $t(`text.approveRequestButtonInfo`) }}
                                </v-card-text>
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                                sm="4">
                                <v-card-text>
                                    <v-icon>report</v-icon>
                                    {{ $t(`text.rejectRequestButtonInfo`) }}
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col> -->
                <v-col
                    cols="12"
                    md="12" class="py-1">
                    <v-card>
                        <v-data-table
							:options.sync="options"
                            :headers="headers"
                            :items="Entities"
                            item-key="id"
                            class="elevation-1"
                            :items-per-page="400"
                            :loading="loading"
                            :loading-text="$t('text.roleRequestsLoading')"
                            :server-items-length="Entities.length"
                            hide-default-footer
							:height="WindowSize.y-382"
                            fixed-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
                                    <v-row>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-btn-toggle dense color="primary">
                                                <v-btn
                                                    color="primary"
                                                    @click="newRequest">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.newRequestButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        add
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>

                                        <v-col cols="12" sm="4" lg="2">
                                            <v-autocomplete outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="tempQP.status"
                                                :items="statuses"
                                                :label="$t('text.status')"
                                                :loading="statusLoading"
                                                @keyup.enter.native="search">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" sm="4" lg="2">
											<v-text-field outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
												v-model="tempQP.userName"
                                                @keyup.enter.native="search"
                                                :label="$t('text.name')"
											></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" lg="2">
                                            <v-autocomplete outlined dense
												:disabled="!organizations.length"
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="tempQP.organizationId"
                                                :items="organizations"
                                                :label="$t('text.organization')"
                                                :loading="orgLoading"
                                                @keyup.enter.native="search">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" sm="12" lg="2">
                                            <v-btn-toggle
                                                dense
                                                color="secondary"
                                                justify="center"
                                                active-class="action-active">
                                                <v-btn
                                                    color="secondary"
                                                    @click="search">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.searchButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        search
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template #[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            v-show="HasRoles && item.isAdmin"
                                            @click="approve(
                                                item.roleId,
                                                item.userId,
                                                item.organizationId)"
                                            :disabled="
                                                item.status === roleRequestStatus.Deleted
                                                || item.status === roleRequestStatus.Approved">
                                            <v-icon>
                                                done
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.approveRequestButtonInfo`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            :disabled="item.status !== roleRequestStatus.Requested"
                                            v-show="HasRoles && item.isAdmin"
                                            @click="reject(
                                                item.roleId,
                                                item.userId,
                                                item.organizationId)">
                                            <v-icon>
                                                report
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.rejectRequestButtonInfo`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="dialogItem = item; dialog = true;"
                                            :disabled="
                                                item.status === roleRequestStatus.Deleted
                                                || item.status === roleRequestStatus.Approved">
                                            <v-icon>
                                                remove_circle
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t(`text.removeRequestButtonInfo`) }}</span>
                                </v-tooltip>
                            </template>
                            <template #[`item.statusLocalized`]="{ item }">
                                <v-chip :color="getStatusColor(item.status)" dark>
                                    {{ item.statusLocalized }}
                                </v-chip>
                            </template>
                            <template #[`item.changedAt`]="{ item }">
                                {{ getLocalFrom(item.changedAt) }}
                            </template>
                        </v-data-table>

                        <pagination
                            :currentPage="Pagination.currentPage"
                            :totalPages="Pagination.totalPages"
                            :pageSize="queryParameters.pageSize"
                            @current="current"
                            @pageSizeChanged="pageSizeChanged">
                        </pagination>
                    </v-card>
                </v-col>
            </v-row>

            <v-dialog
                v-model="dialog"
                width="300">
                <v-card>
                    <v-card-title
                        class="headline grey lighten-2"
                        primary-title>
                        {{ $t(`text.removeRequestNotification`) }}
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="dialogItem = {}; dialog = false;">
                            {{ $t(`text.noButton`) }}
                        </v-btn>
                        <v-btn
                            color="primary"
                            text
                            @click="remove(dialogItem)">
                            {{ $t(`text.yesButton`) }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Page from '../general/Page.vue';
import Pagination from '../general/Pagination.vue';

import roleRequestStatus from '../helpers/roleRequestStatus';

import userRoleActions from '../store/actions/userRole';
import roleRequestActions from '../store/actions/roleRequest';
import namespace from '../store/namespace';

class TempRoleQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.organizationName = qp.organizationName;
			this.userName = qp.userName;
			this.status = qp.status;
			this.organizationId = qp.organizationId;

			this.roleNameDesc = qp.roleNameDesc;
			this.organizationNameDesc = qp.organizationNameDesc;
			this.userNameDesc = qp.userNameDesc;
			this.changedAtDesc = qp.changedAtDesc;
			this.statusLocalizedDesc = qp.statusLocalizedDesc;
		}
	}
}

class RoleQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.organizationName = qp.organizationName;
			this.organizationId = qp.organizationId;
			this.userName = qp.userName;
			this.status = qp.status;
			this.pageNumber = qp.pageNumber;
			this.pageSize = qp.pageSize;

			this.roleNameDesc = qp.roleNameDesc;
			this.organizationNameDesc = qp.organizationNameDesc;
			this.userNameDesc = qp.userNameDesc;
			this.changedAtDesc = qp.changedAtDesc;
			this.statusLocalizedDesc = qp.statusLocalizedDesc;
		} else {
			this.pageNumber = 1;
			this.pageSize = 10;
			this.organizationName = null;
			this.organizationId = null;
			this.userName = null;
			this.status = null;

			this.roleNameDesc = null;
			this.organizationNameDesc = null;
			this.userNameDesc = null;
			this.changedAtDesc = null;
			this.statusLocalizedDesc = null;
		}
	}

	updateTempData(tempQP) {
		this.organizationName = tempQP.organizationName;
		this.organizationId = tempQP.organizationId;
		this.userName = tempQP.userName;
		this.status = tempQP.status;

		this.roleNameDesc = tempQP.roleNameDesc;
		this.organizationNameDesc = tempQP.organizationNameDesc;
		this.userNameDesc = tempQP.userNameDesc;
		this.changedAtDesc = tempQP.changedAtDesc;
		this.statusLocalizedDesc = tempQP.statusLocalizedDesc;
	}
}

export default {
	name: 'RoleRequests',
	components: {
		Page,
		Pagination,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'left', value: 'action', sortable: false, width: 140,
				},
				{
					text: this.$i18n.t('text.headerOrganization'), align: 'left', value: 'organizationName',
				},
				{
					text: this.$i18n.t('text.headerUser'), align: 'left', value: 'userName', width: 200,
				},
				{
					text: this.$i18n.t('text.headerRole'), align: 'left', value: 'roleName', width: 150,
				},
				{
					text: this.$i18n.t('text.headerChangedAt'), align: 'left', value: 'changedAt', width: 150,
				},
				{
					text: this.$i18n.t('text.headerStatus'), align: 'left', value: 'statusLocalized', width: 100,
				},
				{
					text: this.$i18n.t('text.headerReason'), align: 'left', value: 'reason', width: 200,
				},
			],
			organizations: [],
			orgLoading: false,
			options: {},
			loading: true,
			dialog: false,
			dialogItem: {},
			statusLoading: false,
			statuses: [],
			queryParameters: new RoleQueryParameter(),
			tempQP: new TempRoleQueryParameter(),
			help: [{
				icon: 'remove_circle',
				text: this.$t('text.removeRequestButtonInfo'),
			},
			{
				icon: 'done',
				text: this.$t('text.approveRequestButtonInfo'),
			},
			{
				icon: 'report',
				text: this.$t('text.rejectRequestButtonInfo'),
			}],
		};
	},
	async mounted() {
		this.queryParameters.statusLocalizedDesc = false;
		if (localStorage.getItem('roleRequestApp')) {
			this.queryParameters = new RoleQueryParameter(JSON.parse(localStorage.getItem('roleRequestApp')));
			this.tempQP = new TempRoleQueryParameter(this.queryParameters);
		} else {
			localStorage.setItem('roleRequestApp', JSON.stringify(this.queryParameters));
		}
		// this.queryParameters.statusLocalizedDesc = false;
		await this.loadData();
		await this.getRequestStatuses();
		await this.getOrganizations();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.USER, ['IsAdminForOrg', 'HasRoles', 'User']),
		...mapGetters(namespace.ORGANIZATION, ['HasOrganization', 'Organization']),
		...mapGetters(namespace.ROLEREQUEST, ['Links', 'Entities', 'Pagination']),
		roleRequestStatus() {
			return roleRequestStatus;
		},
		nonContentPage() {
			return this.Entities.length == 0;
		},
	},
	watch: {
		async Organization() {
			await this.loadData();
		},
		options: {
			async handler(opt) {
				if (opt.sortBy && opt.sortBy.length > 0) {
					this.queryParameters.roleNameDesc = null;
					this.queryParameters.organizationNameDesc = null;
					this.queryParameters.userNameDesc = null;
					this.queryParameters.changedAtDesc = null;
					this.queryParameters.statusLocalizedDesc = null;

					const sortRoleName = opt.sortBy.find(x => x === 'roleName');
					const sortOrganizationName = opt.sortBy.find(x => x === 'organizationName');
					const sortUserName = opt.sortBy.find(x => x === 'userName');
					const sortChangedAt = opt.sortBy.find(x => x === 'changedAt');
					const sortStatusLocalized = opt.sortBy.find(x => x === 'statusLocalized');

					const sortDesc = opt.sortDesc && opt.sortDesc[0] === true;

					if (sortRoleName) {
						this.queryParameters.roleNameDesc = sortDesc;
					}

					if (sortOrganizationName) {
						this.queryParameters.organizationNameDesc = sortDesc;
					}

					if (sortUserName) {
						this.queryParameters.userNameDesc = sortDesc;
					}

					if (sortChangedAt) {
						this.queryParameters.changedAtDesc = sortDesc;
					}

					if (sortStatusLocalized) {
						this.queryParameters.statusLocalizedDesc = sortDesc;
					}
				}

				await this.loadData(this.queryParameters);
			},
		},
		queryParameters: {
			deep: true,
			handler() {
				localStorage.setItem('roleRequestApp', JSON.stringify(this.queryParameters));
			},
		},
	},
	methods: {
		...mapActions(namespace.ROLEREQUEST, [
			roleRequestActions.GET_ROLE_REQUESTS,
			roleRequestActions.UPDATE_ROLE_REQUEST,
			roleRequestActions.GET_REQUESTS_STATUSES]),
		...mapActions(namespace.USERROLE, [
			userRoleActions.FETCH_USERS_ROLES_ORGANIZATIONS]),
		async approve(roleId, userId, organizationId) {
			const roleRequest = this.Entities.find(request => request.roleId === roleId
                && request.userId === userId
                && request.organizationId === organizationId);

			const link = roleRequest.links.find(x => x.rel === 'update');

			if (roleRequest && link) {
				const item = {
					status: 2,
					reason: '',
					link,
				};

				await this.update(item);
			}
		},
		async remove(item) {
			this.dialog = false;

			const roleRequest = this.Entities.find(request => request.roleId === item.roleId
                && request.userId === item.userId
                && request.organizationId === item.organizationId);

			this.dialogItem = {};

			const link = roleRequest.links.find(x => x.rel === 'update');

			if (roleRequest && link) {
				const itemData = {
					status: 3,
					reason: '',
					link,
				};

				await this.update(itemData);
			}
		},
		reject(roleId, userId, organizationId) {
			this.$router.push({
				name: 'rejectrolerequest',
				params: {
					roleId,
					userId,
					organizationId,
				},
			});
		},
		newRequest() {
			this.$router.push({
				name: 'newrolerequest',
			});
		},
		async loadData() {
			this.loading = true;
			try {
				await this.GET_ROLE_REQUESTS({
					organizationId: this.Organization,
					queryParameters: this.queryParameters,
				});
				if (this.nonContentPage) {
					this.queryParameters.pageNumber = this.Pagination.totalPages;
				}
			} finally {
				this.loading = false;
			}
		},
		async getRequestStatuses() {
			this.statusLoading = true;
			try {
				this.statuses = await this.GET_REQUESTS_STATUSES();
			} finally {
				this.statusLoading = false;
			}
		},
		async search() {
			this.queryParameters.updateTempData(this.tempQP);
			localStorage.setItem('roleRequestApp', JSON.stringify(this.queryParameters));
			this.queryParameters.pageNumber = 1;
			await this.loadData();
		},
		getStatusColor(status) {
			switch (status) {
			case roleRequestStatus.Deleted: return 'gray';
			case roleRequestStatus.Approved: return 'green';
			case roleRequestStatus.Rejected: return 'red';
			case roleRequestStatus.Requested: return 'blue';
			default: return 'white';
			}
		},
		getLocalFrom(date) {
			return this.$moment.utc(date).fromNow();
		},
		async getOrganizations() {
			if (this.Organization != '') {
				this.orgLoading = true;
				try {
					this.organizations = await this.FETCH_USERS_ROLES_ORGANIZATIONS(
						this.Organization,
					);
				} finally {
					this.orgLoading = false;
				}
			}
		},
		async pageSizeChanged(newPageSize) {
			this.queryParameters.pageSize = newPageSize;
			const maxPage = Math.ceil(this.Pagination.totalCount / newPageSize);
			this.queryParameters.pageNumber = maxPage < this.Pagination.currentPage ? maxPage : this.Pagination.currentPage;

			await this.loadData();
		},
		async current(newPage) {
			this.queryParameters.pageNumber = newPage;
			await this.loadData();
		},
		async update(item) {
			this.loading = true;
			try {
				await this.UPDATE_ROLE_REQUEST(item);

				await this.loadData();
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}
</style>
